import { FormattedMessage } from 'react-intl';
import React, { useState } from 'react';
import Dialog from '@mui/material/Dialog';
import DialogTitle from '@mui/material/DialogTitle';
import {
  Box,
  Button,
  CircularProgress,
  DialogActions,
  DialogContent,
  Typography,
} from '@mui/material';
import DialogCloseButton from '@product-framework/components/Dialogs/DialogCloseButton';
import { IconLibrary } from '@product-framework/index';
import {
  useDataProvider,
  useLocalization,
  useSnackbar,
} from '@ui-framework/index';

function LaborMatrixRateRuleDeleteDialog({ parentId, open, onClose, id }) {
  const { formatMessage } = useLocalization();
  const [loading, setLoading] = useState(false);
  const snackbar = useSnackbar();
  const provider =
    process.env.NODE_ENV === 'development' ? 'sxclServices' : 'default';
  const { getApiUrl, remove } = useDataProvider(provider);

  async function onFormSubmit(data) {
    setLoading(true);
    const response = await remove(
      `${getApiUrl()}/sxcl/v1/labor-matrices/${parentId}/rate-rules/${id}`,
      data,
    );
    if (response.ok) {
      snackbar.showMessage(
        formatMessage({
          id: 'LABOR_MATRIX_ROW_DELETED_SUCCESSFULLY',
          defaultMessage: 'Labor Matrix row deleted successfully',
        }),
      );
      onClose();
    } else {
      snackbar.showMessage({
        type: 'error',
        data: formatMessage({
          id: 'ERROR_COULD_NOT_DELETE_LABOR_MATRIX_ROW',
          defaultMessage: 'Error: Could not delete labor matrix row',
        }),
      });
    }
    setLoading(false);
  }

  const buttons = [
    {
      children: formatMessage({
        id: 'CONFIRM',
        defaultMessage: 'Confirm',
      }),
      variant: 'contained',
      color: 'primary',
      onClick: () => onFormSubmit(true),
    },
    {
      children: formatMessage({ id: 'CANCEL', defaultMessage: 'Cancel' }),
      onClick: onClose,
      variant: 'contained',
      color: 'secondary',
    },
  ];

  return (
    <Dialog open={open !== null} onClose={onClose} maxWidth="sm" fullWidth>
      <DialogTitle sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
        <IconLibrary.LaborMatrix />
        {formatMessage({
          id: 'LABOR_MATRIX',
          defaultMessage: 'Labor Matrix',
        })}
        <DialogCloseButton disabled={loading} onClose={onClose} />
      </DialogTitle>
      <DialogContent>
        {loading ? (
          <Box textAlign="center">
            <CircularProgress size="30px" />
            <Typography>
              <FormattedMessage id="PROCESSING" defaultMessage="Processing" />
              ...
            </Typography>
          </Box>
        ) : (
          <Typography>
            <FormattedMessage
              id="DO_YOU_WANT_TO_DELETE"
              defaultMessage="Do you want to delete?"
            />
          </Typography>
        )}
      </DialogContent>
      <DialogActions display="flex" sx={{ justifyContent: 'center', my: 2 }}>
        {buttons.map(btn => {
          const { children, ...rest } = btn;
          return (
            <Button key={children} disabled={loading} {...rest}>
              {children}
            </Button>
          );
        })}
      </DialogActions>
    </Dialog>
  );
}

export default LaborMatrixRateRuleDeleteDialog;
